import React from 'react';
import styles from './SubscriptionOffering.module.scss';
import checkmark from '../../assets/images/checkmark.svg';
import { useNavigate } from 'react-router-dom';
import type { SubscriptionPlan } from '../../types/payment.types';
import { buildJoinUrl } from '../../utils/join';
import { formatSubscriptionPrice } from '../../utils/subscription-plans';

interface SubscriptionOfferingProps {
    offering: SubscriptionPlan;
    onSelect?: (offering: SubscriptionPlan) => void;
    actionLabel?: string;
    isSelected?: boolean;
}


const SubscriptionOffering = (props: SubscriptionOfferingProps) => {
    const navigate = useNavigate();
    const { offering, onSelect, actionLabel, isSelected } = props;
    const isDisabled = !offering.offeringId;

    const handleSubscribeClick = () => {
        if (isDisabled) {
            return;
        }
        if (onSelect) {
            onSelect(offering);
            return;
        }
        navigate(buildJoinUrl({
            offeringId: offering.offeringId,
            market: offering.marketCode,
            source: 'pricing'
        }));
    };

    return (
        <div
            className={[
                styles['SubscriptionOffering'],
                offering.isFeatured ? styles['featured'] : '',
                isSelected ? styles['selected'] : ''
            ].join(' ')}
        >
            <div className={styles['header']}>
                {offering.badge ? <span className={styles['badge']}>{offering.badge}</span> : null}
                <h3 className={styles['duration']}>{offering.duration}</h3>
                {offering.tagline ? <p className={styles['tagline']}>{offering.tagline}</p> : null}
            </div>
            <div className={styles['priceRow']}>
                <span className={styles['price']}>{formatSubscriptionPrice(offering)}</span>
                <span className={styles['priceInterval']}>/ {offering.duration.toLowerCase()}</span>
            </div>
            <ul className={styles['features']}>
                {offering.descriptors.map((description, index) => (
                    <li key={index} className={styles['featureItem']}>
                        <img src={checkmark} alt="" className={styles['checkmark']} aria-hidden="true" />
                        <span>{description}</span>
                    </li>
                ))}
            </ul>
            <button
                type="button"
                className={[styles['subscribeButton'], isDisabled ? styles['disabled'] : ''].join(' ')}
                onClick={handleSubscribeClick}
                disabled={isDisabled}
            >
                {actionLabel || (isSelected ? 'Selected' : 'Subscribe now')}
            </button>
        </div>
    );
}

export default SubscriptionOffering;
